<template>
    <div>

      <Loader :visible="isLoading" :text="loadingText" />
      <div class="p-6 pb-0">
        <BreadCrumbs :navigation="navigation" />
      </div>
  
      <div class="p-6 pb-24">
        <!-- Selezione tipologia ricerca -->
        <div class="bg-white rounded-lg border border-gray-200 shadow-sm">
          <div class="p-5 border-b border-gray-200">
            <h2 class="text-lg font-semibold text-gray-800">
              Ricerca informazioni ordini
            </h2>
  
            <p class="mt-1 text-sm text-gray-500">
              Seleziona la modalità di ricerca desiderata.
            </p>
          </div>
  
          <div class="p-5">
            <div class="grid grid-cols-1 sm:grid-cols-2 gap-3 mb-6">
              <button
                type="button"
                class="flex items-center justify-center gap-2 px-4 py-3 rounded-lg border transition-colors"
                :class="searchType === 'item'
                  ? 'border-blue-500 bg-blue-50 text-blue-700'
                  : 'border-gray-300 bg-white text-gray-600 hover:bg-gray-50'"
                @click="setSearchType('item')"
              >
                <span class="font-medium">
                  Ricerca per articolo
                </span>
              </button>
  
              <button
                type="button"
                class="flex items-center justify-center gap-2 px-4 py-3 rounded-lg border transition-colors"
                :class="searchType === 'order'
                  ? 'border-blue-500 bg-blue-50 text-blue-700'
                  : 'border-gray-300 bg-white text-gray-600 hover:bg-gray-50'"
                @click="setSearchType('order')"
              >
                <span class="font-medium">
                  Ricerca per ordine
                </span>
              </button>
            </div>
  
            <!-- Ricerca per articolo -->
            <form
              v-if="searchType === 'item'"
              class="space-y-4"
              @submit.prevent="searchByItem"
            >
              <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div>
                  <label
                    for="item-code"
                    class="block mb-1 text-sm font-medium text-gray-700"
                  >
                    Codice articolo
                  </label>
  
                  <input
                    id="item-code"
                    v-model.trim="itemForm.item"
                    type="text"
                    autocomplete="off"
                    placeholder="Inserisci il codice articolo"
                    class="w-full px-3 py-2 border border-gray-300 rounded-md text-sm
                           focus:outline-none focus:ring-2 focus:ring-blue-500
                           focus:border-blue-500"
                  >
                </div>
  
                <div>
                  <label
                    for="item-description"
                    class="block mb-1 text-sm font-medium text-gray-700"
                  >
                    Descrizione
                  </label>
  
                  <input
                    id="item-description"
                    v-model.trim="itemForm.description"
                    type="text"
                    autocomplete="off"
                    placeholder="Inserisci parte della descrizione"
                    class="w-full px-3 py-2 border border-gray-300 rounded-md text-sm
                           focus:outline-none focus:ring-2 focus:ring-blue-500
                           focus:border-blue-500"
                  >
                </div>
              </div>
  
              <p
                v-if="validationError"
                class="text-sm text-red-600"
              >
                {{ validationError }}
              </p>
  
              <div class="flex flex-wrap justify-end gap-2 pt-2">
                <button
                  type="button"
                  class="px-4 py-2 text-sm font-medium text-gray-600 bg-white
                         border border-gray-300 rounded-md hover:bg-gray-50"
                  @click="resetItemForm"
                >
                  Pulisci
                </button>
  
                <button
                  type="submit"
                  :disabled="loading"
                  class="px-4 py-2 text-sm font-medium text-white bg-blue-600
                         rounded-md hover:bg-blue-700 disabled:opacity-50
                         disabled:cursor-not-allowed"
                >
                  {{ loading ? 'Ricerca in corso...' : 'Cerca articolo' }}
                </button>
              </div>
            </form>
  
            <!-- Ricerca per ordine -->
            <form
              v-else
              class="space-y-4"
              @submit.prevent="searchByOrder"
            >
              <div class="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div>
                  <label
                    for="order-number"
                    class="block mb-1 text-sm font-medium text-gray-700"
                  >
                    Numero ordine
                  </label>
  
                  <input
                    id="order-number"
                    v-model.trim="orderForm.order_number"
                    type="text"
                    autocomplete="off"
                    placeholder="Inserisci il numero ordine"
                    class="w-full px-3 py-2 border border-gray-300 rounded-md text-sm
                           focus:outline-none focus:ring-2 focus:ring-blue-500
                           focus:border-blue-500"
                  >
                </div>
  
                <div>
                  <label
                    for="customer"
                    class="block mb-1 text-sm font-medium text-gray-700"
                  >
                    Cliente
                  </label>
  
                  <input
                    id="customer"
                    v-model.trim="orderForm.customer"
                    type="text"
                    autocomplete="off"
                    placeholder="Codice o ragione sociale"
                    class="w-full px-3 py-2 border border-gray-300 rounded-md text-sm
                           focus:outline-none focus:ring-2 focus:ring-blue-500
                           focus:border-blue-500"
                  >
                </div>

              </div>
  
              <p
                v-if="validationError"
                class="text-sm text-red-600"
              >
                {{ validationError }}
              </p>
  
              <div class="flex flex-wrap justify-end gap-2 pt-2">
                <button
                  type="button"
                  class="px-4 py-2 text-sm font-medium text-gray-600 bg-white
                         border border-gray-300 rounded-md hover:bg-gray-50"
                  @click="resetOrderForm"
                >
                  Pulisci
                </button>
  
                <button
                  type="submit"
                  :disabled="loading"
                  class="px-4 py-2 text-sm font-medium text-white bg-blue-600
                         rounded-md hover:bg-blue-700 disabled:opacity-50
                         disabled:cursor-not-allowed"
                >
                  {{ loading ? 'Ricerca in corso...' : 'Cerca ordine' }}
                </button>
              </div>
            </form>
          </div>
        </div>

        <div class="mt-2">
          <PageServerTable
            :headers="localHeaders"
            :items="localItems"
            :items-length="localTotal"
            :sort-by="localSortBy"
            :page="localPage"
            :items-per-page="localIpp"
            :items-per-page-options="ippo"
            :reload-fn="reloadFn"
            :item-value="itemKey"
            show-current-page
            show-expand
          >
            <template #item.CompanyName="{ item }">
              <span class="font-semibold text-gray-800">{{ item.CompanyName }}</span>
              <span v-if="item.Supplier" class="block text-xs text-gray-400">{{ item.Supplier }}</span>
            </template>

            <template #item.InternalOrdNo="{ item }">
              <span class="font-semibold text-gray-800">{{ item.InternalOrdNo }}</span>
              <span v-if="item.OrderDate" class="block text-xs text-gray-400">{{ formatDate(item.OrderDate) }}</span>
            </template>

            <template #item.MA_PurchaseOrdDetails.Job="{ item }">
              <span
                class="block overflow-hidden text-ellipsis whitespace-nowrap text-gray-700"
                style="max-width: 100px"
                :title="item.Job"
              >{{ item.Job }}</span>
            </template>

            <template #item.JobCompanyName="{ item }">
              <span class="font-semibold text-gray-800">{{ item.CustomerCompanyName }}</span>
              <span v-if="item.JobCustomer" class="block text-xs text-gray-400">{{ item.JobCustomer }}</span>
            </template>

            <template #item.Status="{ item }">
              <span
                class="inline-block w-3 h-3 rounded-full"
                :class="item.Delivered == 1
                  ? 'bg-green-500'
                  : item.DeliveredQty != 0
                    ? 'bg-yellow-400'
                    : 'bg-red-500'"
              ></span>
            </template>

            <template #item.data-table-expand="{ internalItem, isExpanded, toggleExpand }">
              <v-icon
                :name="isExpanded(internalItem) ? 'md-keyboardarrowup-round' : 'md-keyboardarrowdown-round'"
                scale="1.2"
                class="cursor-pointer text-gray-700 hover:text-black"
                @click="toggleExpand(internalItem)"
              />
            </template>

            <template #expanded-row="{ columns, item }">
              <tr>
                <td :colspan="columns.length" class="p-0">
                  <div class="bg-gray-50 border-t border-blue-100 px-10 py-3">
                    <p class="text-xs font-semibold text-gray-400 uppercase tracking-wide mb-2">Bolle di carico</p>
                    <table class="w-full text-sm">
                      <thead>
                        <tr class="text-xs text-gray-500 border-b border-gray-200">
                          <!--<th class="px-2 py-1 text-left font-medium">N. Documento</th>-->
                          <th class="px-2 py-1 text-left font-medium">N. Documento Forn.</th>
                          <th class="px-2 py-1 text-left font-medium">Data</th>
                          <th class="px-2 py-1 text-right font-medium">Qta ricevuta</th>
                        </tr>
                      </thead>
                      <tbody class="divide-y divide-gray-100">
                        <template v-if="item.bolle && item.bolle.length">
                          <tr v-for="(doc, idx) in item.bolle" :key="idx">
                            <!--<td class="px-2 py-2 font-medium text-gray-700">{{ doc.InternalDocNo || doc.PurchaseDocId }}</td>-->
                            <td class="px-2 py-2 font-medium text-gray-700">{{ doc.SupplierDocNo }}</td>
                            <td class="px-2 py-2 text-gray-600">{{ doc.DocDate ? formatDate(doc.DocDate) : '-' }}</td>
                            <td class="px-2 py-2 text-right text-gray-700">{{ doc.ReceivedQty }}</td>
                          </tr>
                        </template>
                        <tr v-else>
                          <td colspan="3" class="px-2 py-3 text-center text-xs text-gray-400">Nessuna bolla di carico registrata</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </td>
              </tr>
            </template>

            <template #no-data>
              <div class="px-4 py-10 text-center text-sm text-gray-400">
                {{ lastSearchParams ? 'Nessun risultato trovato.' : 'Effettua una ricerca per visualizzare i risultati.' }}
              </div>
            </template>
          </PageServerTable>
        </div>
  
      </div>
    </div>
</template>
  
<script>
    import { format, parseISO } from 'date-fns';
    import BreadCrumbs from '@/Components/BreadCrumbs.vue';
    import Loader from '@/Components/Loader.vue';
    import PageServerTable from '@/Components/PageServerTable.vue';

    export default {
        props: ['items', 'total', 'ippo', 'headers', 'ipp', 'page', 'sortby', 'showPricelistInfo'],
        components: {
            BreadCrumbs,
            Loader,
            PageServerTable
        },
        data() {
            return {
                navigation: [
                    { name: 'Dashboard', href: route('dashboard') },
                    { name: this.$t('modules.gestione-magazzino'), href: route('modules.home', 'gestione-magazzino') },
                    { name: this.$t('modules.info-ordini'), href: route('modules.gm.infoordini') }
                ],
                searchType: 'item',
                loading: false,
                isLoading: false,
                loadingText: '',
                validationError: '',
                localItems: this.items ?? [],
                localTotal: this.total ?? 0,
                localPage: this.page ?? 1,
                localIpp: this.ipp ?? 10,
                localSortBy: this.sortby ?? [{ key: 'po.OrderDate', order: 'desc' }],
                localHeaders: this.headers ? JSON.parse(JSON.stringify(this.headers)) : [],
                lastSearchParams: null,
                itemForm: {
                    item: '',
                    description: ''
                },
                orderForm: {
                    order_number: '',
                    customer: '',
                }
            };
        },

        mounted() {
            const params = new URLSearchParams(window.location.search);
            const type = params.get('type');
            if (type === 'item' && params.get('item')) {
                this.searchType = 'item';
                this.itemForm.item = params.get('item');
                this.$nextTick(() => this.searchByItem());
            } else if (type === 'order' && params.get('order_number')) {
                this.searchType = 'order';
                this.orderForm.order_number = params.get('order_number');
                this.$nextTick(() => this.searchByOrder());
            }
        },

        methods: {
          setSearchType(type) {
              this.searchType = type;
              this.validationError = '';
              const itemHeader = this.localHeaders.find(h => h.key === 'MA_PurchaseOrdDetails.Item');
              if (type === 'item') {
                this.resetOrderForm();
                if (itemHeader) { itemHeader.filterable = false; itemHeader.filtervalue = ''; }
              } else if (type === 'order') {
                this.resetItemForm();
                if (itemHeader) { itemHeader.filterable = true; }
              }
          },

          resetItemForm() {
              this.itemForm = {
                  item: '',
                  description: ''
              };
          },

          resetOrderForm() {
              this.orderForm = {
                  order_number: '',
                  customer: ''
              };
          },
          

          buildHeaderFilters() {
            const filterKeyMap = {
              'CompanyName':                'cs.CompanyName',
              'InternalOrdNo':              'po.InternalOrdNo',
              'JobCompanyName':             'cc.CompanyName',
              'MA_PurchaseOrdDetails.Item': 'MA_PurchaseOrdDetails.Item',
            };
            if (!this.localHeaders) return [];
            return this.localHeaders
              .filter(h => h.filterable && h.filtervalue && h.filtervalue !== '')
              .map(h => [filterKeyMap[h.key], 'LIKE', h.filtervalue])
              .filter(f => f[0] != null);
          },

          buildOrderBy(sortBy) {
            const sortKeyMap = {
              'CompanyName':                      'po.Supplier',
              'InternalOrdNo':                    'po.InternalOrdNo',
              'MA_PurchaseOrdDetails.Position':   'MA_PurchaseOrdDetails.Position',
              'MA_PurchaseOrdDetails.Job':        'MA_PurchaseOrdDetails.Job',
              'JobCompanyName':                   'j.Customer',
              'MA_PurchaseOrdDetails.Item':       'MA_PurchaseOrdDetails.Item',
              'MA_PurchaseOrdDetails.Description':'MA_PurchaseOrdDetails.Description',
              'MA_PurchaseOrdDetails.Qty':        'MA_PurchaseOrdDetails.Qty',
              'Status':                           null,
              'InternalDocNo':                    'pd.InternalDocNo',
              'pdd.Qty':                          'pdd.Qty',
            };
            if (!sortBy || sortBy.length === 0) return [['po.OrderDate', 'desc']];
            const mapped = sortBy
              .filter(s => sortKeyMap[s.key] != null)
              .map(s => [sortKeyMap[s.key] ?? s.key, s.order]);
            return mapped.length > 0 ? mapped : [['po.OrderDate', 'desc']];
          },

          async fetchData(page, perPage, orderBy, loaderText = 'Caricamento...') {
            this.loading = true;
            this.isLoading = true;
            this.loadingText = loaderText;
            try {
              const response = await axios.post(
                route('modules.gm.infoordini.getOrdini'),
                { ...this.lastSearchParams, page, perPage, orderBy, headerFilters: this.buildHeaderFilters() }
              );
              this.localItems = response.data.data;
              this.localTotal = response.data.total;
              this.localPage = response.data.current_page;
            } finally {
              this.loading = false;
              this.isLoading = false;
            }
          },

          async reloadFn(sortBy, itemsPerPage, page) {
            if (!this.lastSearchParams) return;
            let loaderText = 'Caricamento...';
            if (sortBy !== undefined) {
              this.localSortBy = sortBy;
              page = 1;
              loaderText = 'Ordinamento in corso...';
            } else if (itemsPerPage === undefined && page === undefined) {
              page = 1;
              loaderText = 'Filtraggio in corso...';
            }
            const newPage = page ?? this.localPage;
            const newIpp = itemsPerPage ?? this.localIpp;
            if (itemsPerPage !== undefined) this.localIpp = itemsPerPage;
            await this.fetchData(newPage, newIpp, this.buildOrderBy(this.localSortBy), loaderText);
          },

          async searchByItem() {
            if (!this.itemForm.item && !this.itemForm.description) {
                this.validationError = 'Inserisci almeno un criterio di ricerca.';
                return;
            }
            this.validationError = '';
            this.lastSearchParams = {
              type: 'item',
              item: this.itemForm.item,
              description: this.itemForm.description,
            };
            await this.fetchData(1, this.localIpp, this.buildOrderBy(this.localSortBy), 'Ricerca in corso...');
          },

          async searchByOrder() {
            if (!this.orderForm.order_number && !this.orderForm.customer) {
              this.validationError = 'Inserisci almeno un criterio di ricerca.';
              return;
            }
            this.validationError = '';
            this.lastSearchParams = {
              type: 'order',
              order_number: this.orderForm.order_number,
              customer: this.orderForm.customer,
            };
            await this.fetchData(1, this.localIpp, this.buildOrderBy(this.localSortBy), 'Ricerca in corso...');
          },

          itemKey(item) {
            return `${item.PurchaseOrdId}-${item.Position}`;
          },

          formatDate(dateStr) {
            try {
              return format(parseISO(dateStr), 'dd/MM/yyyy');
            } catch {
              return dateStr;
            }
          },
        }
    };
  
</script>
  